<template>
  <div>
    <Breadcrumb breadcrumb="" />

    <!--Banner get you to github repo-->
    <Banner class="hidden" />

    <!-- cards -->
    <div v-if="loading">
      <div class="flex justify-center items-center h-screen">
        <img :src="loader" alt="Loading..." class="w-8 h-8" />
      </div>
    </div>
    <div v-else class="mt-4">
      <div class="flex w-full items-center justify-between">
        <div class="w-full px-3 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-indigo-600 bg-opacity-75 rounded-full">
              <svg
                class="w-8 h-8 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 9 6" />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">{{ blogs.length }}</h4>
              <div class="text-gray-500">Blogs</div>
            </div>
          </div>
        </div>

        <div class="w-full px-3 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-indigo-600 bg-opacity-75 rounded-full">
              <svg
                class="w-8 h-8 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 9 6" />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">{{ travelGuides.length }}</h4>
              <div class="text-gray-500 whitespace-nowrap">Travel Guides</div>
            </div>
          </div>
        </div>

        <div class="w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-pink-600 bg-opacity-75 rounded-full">
              <svg class="w-8 h-8 text-white" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="12" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                <line x1="14" y1="14" x2="14" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="14" y1="14" x2="18" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">
                {{ blogs.filter((blog) => blog.status.name === "pending").length + travelGuides.filter((guide) => guide.status.name === "pending").length }}
              </h4>
              <div class="text-gray-500">Pending</div>
            </div>
          </div>
        </div>

        <div class="w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-blue-600 bg-opacity-75 rounded-full">
              <svg class="w-8 h-8 text-white" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13" stroke="currentColor" stroke-width="2" />
                <path d="M8 15l5 5 9-10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">
                {{ blogs.filter((blog) => blog.status.name === "approved").length + travelGuides.filter((guide) => guide.status.name === "approved").length }}
              </h4>
              <div class="text-gray-500">Approved</div>
            </div>
          </div>
        </div>

        <div class="w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-blue-600 bg-opacity-75 rounded-full">
              <svg class="w-8 h-8 text-white" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- Document outline with a folded corner -->
                <path d="M4 4H16L20 8V24H4V4Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                <polyline points="16 4 16 8 20 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <!-- Check mark indicating published -->
                <path d="M8 15L12 19L18 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">
                {{ blogs.filter((blog) => blog.status.name === "published").length + travelGuides.filter((guide) => guide.status.name === "published").length }}
              </h4>
              <div class="text-gray-500">Published</div>
            </div>
          </div>
        </div>

        <div class="w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0">
          <div class="flex items-center px-5 py-6 bg-white rounded-md shadow-sm">
            <div class="p-3 bg-red-600 bg-opacity-75 rounded-full text-center">
              <svg class="w-8 h-8 text-white" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- cross mark indicating refused -->
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke="currentColor"
                  stroke-width="2"
                  d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            </div>

            <div class="mx-5">
              <h4 class="text-2xl font-semibold text-gray-700">
                {{ blogs.filter((blog) => blog.status.name === "refused").length + travelGuides.filter((guide) => guide.status.name === "refused").length }}
              </h4>
              <div class="text-gray-500">Refused</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- user should be able to redirect to the frontend site -->
        <span>Click here to redirect to the</span>
        <a href="https://helayes.com" target="_blank" class="mt-4 inline-block px-2 text-blue-600 underline hover:text-blue-700 font-semibold">
          <strong>helayes.com</strong>
        </a>
      </div>
    </div>

    <div class="mt-8"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from "vue";
import axios from "axios";
import Banner from "../partials/AppBanner.vue";
import Breadcrumb from "../partials/AppBreadcrumb.vue";
const baseUrl = process.env.VUE_APP_BASE_URL;
import loader from "../assets/loader.svg";

interface Status {
  name: string;
}

interface BlogOrGuide {
  status: Status;
  [key: string]: any;
}

const blogs = ref<BlogOrGuide[]>([]);
const travelGuides = ref<BlogOrGuide[]>([]);
const loading = ref(true);
const tableHeadings = ["title", "category", "type", "status", "created at", "published at", "views", "action"];

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString();
};

const fetchBlogs = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/blog/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    blogs.value = response.data.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const fetchTravelGuides = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/tour-guide/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    travelGuides.value = response.data.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const initialProcess = async () => {
  await fetchBlogs();
  await fetchTravelGuides();
};

onMounted(() => {
  initialProcess();
});
</script>
